import { render } from "./BlogImplantsPain.vue?vue&type=template&id=6322a536"
import script from "./BlogImplantsPain.vue?vue&type=script&lang=js"
export * from "./BlogImplantsPain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__